var _path, _path2, _ellipse, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPetsAllowed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 27"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M10.672 6.124c1.128-1.053 2.685-1.658 4.32-1.676s3.21.55 4.367 1.576M22.28 14.553c-.615 4.1-2.873 7.764-7.21 7.764-4.335 0-6.594-3.663-7.209-7.764"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M10.665 6.982c.172-.605-.022-1.245-.51-1.691-.49-.446-1.204-.634-1.888-.497-1.202.261-2.223.963-2.811 1.931-1.006 1.491-.159 3.472.725 4.867.24.383.696.619 1.19.614.492-.006.943-.251 1.172-.64a22 22 0 0 0 2.122-4.584M19.335 6.982c-.172-.604.022-1.245.511-1.691.49-.447 1.205-.635 1.889-.496 1.201.261 2.222.963 2.81 1.93 1.005 1.492.158 3.472-.725 4.867-.24.384-.697.62-1.19.614-.493-.005-.943-.25-1.173-.64a22 22 0 0 1-2.122-4.584",
  clipRule: "evenodd"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 15.071,
  cy: 16.941,
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  rx: 2.014,
  ry: 1.195
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M11.39 21.202c2.193-.418 3.68-3.065 3.68-3.065s1.488 2.647 3.68 3.065M12.05 11.566c.185 0 .335.134.335.299M11.714 11.865c0-.165.15-.299.335-.299M12.05 12.164c-.186 0-.336-.134-.336-.299"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12.386 11.865c0 .165-.15.299-.336.299M18.092 11.566c.185 0 .335.134.335.299M17.756 11.865c0-.165.15-.299.335-.299M18.092 12.164c-.186 0-.336-.134-.336-.299M18.428 11.865c0 .165-.15.299-.336.299"
})));
export default SvgPetsAllowed;